import { motion } from "framer-motion";
import { eyebrowFor } from "@/content/sections";
import { reveal } from "@/lib/motion";

const chapters = [
  { n: "01", title: "Speed is a promise", body: "Loads don't wait, and neither do we. Our dispatch runs 24/7 with sub-hour quote turnarounds so your freight is booked before your competitor picks up the phone." },
  { n: "02", title: "Vetted, always", body: "Every carrier in our network is FMCSA-verified, insured and scored. We move your cargo only with partners who protect it like their own." },
  { n: "03", title: "Data you can see", body: "Real-time tracking, proactive exception alerts and clean documentation. No black boxes, no guessing where your shipment is." },
  { n: "04", title: "People who answer", body: "Behind the tech is a team that knows your lanes by name. One point of contact, total accountability, zero runaround." },
];

export const Manifesto = () => {
  return (
    <section id="manifesto" className="relative z-10 bg-[#0a0a0a] py-28 lg:py-40" data-testid="manifesto">
      <div className="mx-auto max-w-[1500px] px-6 lg:px-12">
        <div className="mb-20 max-w-2xl">
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-neon">{eyebrowFor("manifesto")}</span>
          <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-none tracking-tight text-white md:text-6xl">
            How we move.
          </h2>
        </div>

        <div className="grid gap-px md:grid-cols-2">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              {...reveal}
              transition={{ ...reveal.transition, delay: (i % 2) * 0.1 }}
              data-testid={`manifesto-chapter-${c.n}`}
              className="relative border-b border-white/10 py-12 md:px-10 md:odd:border-r"
            >
              <span className="stroke-text font-display text-7xl font-bold md:text-8xl">{c.n}</span>
              <h3 className="mt-6 font-display text-3xl font-semibold uppercase text-white">{c.title}</h3>
              <p className="mt-4 max-w-md leading-relaxed text-zinc-400">{c.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
